module.exports = __webpack_public_path__ + "static/media/g-j-logo.3a0e00a6.png";